import { Routes } from '@angular/router';
import { AuthGuard } from '@app/core/shared';
import { RegistrationApprovalComponent } from './users/registration-approval/registration-approval.component';

export const ExtensionRoutes: Routes = [
    {
        path: 'promotionwisemoq/promotionwisecarryforwardreport',
        loadChildren: () => import('./promotionwiseMOQ/promotionwisemoq.module').then(module => module.PromotionwisemoqModule),
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: { title: 'PromotionWiseMOQ', isPreLogin: false }
    },

    {
        path: 'registrationapproval',
        component: RegistrationApprovalComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
        data: { title: 'RegistrationApproval', isPreLogin: false }
    }
];